function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeeper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.095 35.117 l -2.715 -1.277 l 5.203 -11.052 c 0.208 -0.441 0.229 -0.938 0.061 -1.401 c -0.171 -0.47 -0.516 -0.845 -0.97 -1.055 c -0.944 -0.437 -2.074 -0.034 -2.513 0.899 l -5.203 11.051 l -2.715 -1.277 l 5.203 -11.052 c 1.14 -2.419 4.05 -3.472 6.485 -2.345 c 1.185 0.548 2.085 1.525 2.531 2.752 c 0.444 1.22 0.386 2.536 -0.165 3.705 L 76.095 35.117 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "currentColor",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82.014 38.415 l -2.715 -1.277 l 4.62 -9.814 c 0.208 -0.441 0.229 -0.938 0.061 -1.401 c -0.171 -0.47 -0.516 -0.845 -0.97 -1.055 c -0.944 -0.437 -2.074 -0.034 -2.513 0.899 l -5.812 12.346 l -2.715 -1.277 l 5.812 -12.347 c 1.14 -2.419 4.05 -3.472 6.485 -2.345 c 1.185 0.548 2.085 1.525 2.531 2.752 c 0.444 1.22 0.386 2.536 -0.165 3.705 L 82.014 38.415 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "currentColor",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73.547 66.282 l -20.375 -9.411 l 0.227 -3.155 c 0.304 -4.234 -0.33 -5.614 -1.593 -8.362 c -0.536 -1.168 -1.144 -2.491 -1.81 -4.303 l -2.3 -6.259 c -0.445 -1.212 -0.388 -2.527 0.16 -3.703 c 0.553 -1.185 1.533 -2.081 2.763 -2.524 c 2.53 -0.909 5.334 0.39 6.257 2.898 l 1.189 3.169 l 6.813 -14.47 c 1.138 -2.418 4.047 -3.471 6.485 -2.345 c 1.185 0.548 2.085 1.526 2.531 2.753 c 0.443 1.22 0.385 2.536 -0.165 3.705 l -5.268 11.19 l -2.715 -1.278 l 5.268 -11.19 c 0.208 -0.44 0.229 -0.938 0.061 -1.401 c -0.171 -0.471 -0.516 -0.845 -0.97 -1.055 c -0.948 -0.437 -2.074 -0.034 -2.513 0.899 l -9.838 20.897 l -3.691 -9.828 c -0.358 -0.977 -1.447 -1.474 -2.427 -1.121 c -0.472 0.17 -0.849 0.515 -1.061 0.97 c -0.208 0.447 -0.23 0.944 -0.062 1.4 l 2.3 6.258 c 0.625 1.702 1.207 2.968 1.72 4.086 c 1.336 2.907 2.218 4.828 1.859 9.83 l -0.078 1.087 l 15.81 7.301 c 1.838 -3.613 3.525 -5.738 5.162 -7.798 c 1.448 -1.823 2.815 -3.546 4.259 -6.274 l 5.283 -11.226 c 0.208 -0.441 0.229 -0.938 0.061 -1.401 c -0.171 -0.471 -0.516 -0.846 -0.97 -1.055 c -0.947 -0.438 -2.075 -0.035 -2.514 0.899 l -2.669 5.669 l -2.715 -1.277 l 2.669 -5.669 c 1.14 -2.42 4.048 -3.471 6.486 -2.345 c 1.185 0.547 2.084 1.525 2.531 2.752 c 0.444 1.22 0.385 2.536 -0.165 3.705 l -5.314 11.288 c -1.604 3.037 -3.124 4.95 -4.594 6.799 c -1.802 2.269 -3.504 4.413 -5.451 8.548 L 73.547 66.282 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "currentColor",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.46,72.84 49.65,63.24 53.38,55.31 56.1,56.58 53.65,61.78 69.01,68.87 71.47,63.66 74.18,64.94 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "currentColor",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.905 35.117 L 8.702 24.065 c -0.55 -1.169 -0.609 -2.485 -0.165 -3.705 c 0.446 -1.227 1.345 -2.204 2.53 -2.752 c 2.438 -1.123 5.347 -0.073 6.486 2.345 l 5.203 11.051 l -2.714 1.278 l -5.203 -11.052 c -0.439 -0.934 -1.567 -1.336 -2.514 -0.899 c -0.454 0.21 -0.798 0.584 -0.97 1.055 c -0.168 0.463 -0.147 0.96 0.061 1.401 l 5.203 11.052 L 13.905 35.117 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "currentColor",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.986 38.415 l -4.62 -9.814 c -0.55 -1.169 -0.609 -2.485 -0.165 -3.705 c 0.446 -1.227 1.345 -2.204 2.53 -2.752 c 2.439 -1.124 5.347 -0.073 6.486 2.345 l 5.812 12.346 l -2.714 1.278 L 9.503 25.767 c -0.439 -0.934 -1.567 -1.336 -2.514 -0.899 c -0.454 0.21 -0.798 0.584 -0.97 1.055 c -0.168 0.463 -0.147 0.96 0.061 1.401 l 4.62 9.814 L 7.986 38.415 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "currentColor",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.453 66.282 l -0.634 -1.348 c -1.947 -4.136 -3.65 -6.279 -5.452 -8.547 c -1.469 -1.851 -2.988 -3.763 -4.562 -6.738 L 0.46 38.299 c -0.551 -1.169 -0.609 -2.484 -0.166 -3.704 c 0.447 -1.227 1.346 -2.205 2.531 -2.752 c 2.437 -1.126 5.347 -0.075 6.485 2.345 l 2.669 5.669 l -2.714 1.278 l -2.669 -5.669 c -0.44 -0.934 -1.567 -1.338 -2.514 -0.899 c -0.454 0.209 -0.799 0.584 -0.97 1.055 c -0.168 0.463 -0.147 0.96 0.06 1.4 l 5.314 11.289 c 1.413 2.667 2.78 4.388 4.228 6.212 c 1.637 2.061 3.324 4.185 5.162 7.798 l 15.809 -7.301 l -0.078 -1.087 c -0.358 -5.003 0.524 -6.923 1.859 -9.83 c 0.513 -1.117 1.095 -2.384 1.72 -4.085 l 2.3 -6.259 c 0.167 -0.456 0.145 -0.953 -0.063 -1.4 c -0.212 -0.455 -0.589 -0.8 -1.061 -0.97 c -0.983 -0.354 -2.068 0.145 -2.423 1.11 l -3.695 9.838 l -9.837 -20.896 c -0.439 -0.932 -1.564 -1.335 -2.514 -0.899 c -0.454 0.21 -0.799 0.584 -0.97 1.055 c -0.169 0.463 -0.147 0.96 0.06 1.401 l 5.268 11.19 l -2.714 1.278 l -5.268 -11.19 c -0.551 -1.169 -0.609 -2.485 -0.166 -3.705 c 0.447 -1.227 1.346 -2.205 2.531 -2.753 c 2.437 -1.123 5.347 -0.073 6.485 2.345 l 6.812 14.47 l 1.194 -3.179 c 0.918 -2.5 3.724 -3.801 6.253 -2.888 c 1.229 0.443 2.21 1.34 2.763 2.524 c 0.548 1.176 0.605 2.491 0.16 3.702 l -2.3 6.259 c -0.665 1.811 -1.273 3.135 -1.809 4.303 c -1.263 2.749 -1.896 4.129 -1.593 8.363 l 0.226 3.155 L 16.453 66.282 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "currentColor",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.54,72.84 15.82,64.94 18.53,63.66 20.99,68.87 36.35,61.78 33.9,56.58 36.62,55.31 40.35,63.24 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "currentColor",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeeper);
export default __webpack_public_path__ + "static/media/keeper.353b8101.svg";
export { ForwardRef as ReactComponent };